import React from 'react';

export const TwoColumns = ({ left, right, className, style }) => (
  <div className={`row row--with_margin flex-md-nowrap ${className}`}>
    <div className="col-12 col-md-6 space-y" style={style}>
      {left}
    </div>
    <div className="col-12 col-md-6 mt-2 mt-md-0 space-y-sm dropContainer">
      {right}
    </div>
  </div>
);
